import React from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { Layout, Images, Gear } from '@phosphor-icons/react';

export function TemplatesPage() {
  return (
    <DashboardLayout>
      <div className="p-6 lg:p-8">
        <div className="mb-6">
          <h1 className="text-3xl font-black tracking-tight text-zinc-900">Templates</h1>
          <p className="text-zinc-500 mt-1">Design and manage ticket templates</p>
        </div>
        <div className="bg-white border border-zinc-200 rounded-sm p-12 text-center">
          <Layout className="w-16 h-16 text-zinc-300 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-zinc-900 mb-2">Template Designer</h2>
          <p className="text-zinc-500 max-w-md mx-auto">
            Visual template designer coming soon. You'll be able to create custom ticket layouts with drag-and-drop placeholders.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
}

export function MediaPage() {
  return (
    <DashboardLayout>
      <div className="p-6 lg:p-8">
        <div className="mb-6">
          <h1 className="text-3xl font-black tracking-tight text-zinc-900">Media Library</h1>
          <p className="text-zinc-500 mt-1">Manage images and assets</p>
        </div>
        <div className="bg-white border border-zinc-200 rounded-sm p-12 text-center">
          <Images className="w-16 h-16 text-zinc-300 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-zinc-900 mb-2">Media Library</h2>
          <p className="text-zinc-500 max-w-md mx-auto">
            Upload and manage logos, backgrounds, and other assets for your campaigns.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
}

export function SettingsPage() {
  return (
    <DashboardLayout>
      <div className="p-6 lg:p-8">
        <div className="mb-6">
          <h1 className="text-3xl font-black tracking-tight text-zinc-900">System Settings</h1>
          <p className="text-zinc-500 mt-1">Configure platform-wide settings</p>
        </div>
        <div className="bg-white border border-zinc-200 rounded-sm p-12 text-center">
          <Gear className="w-16 h-16 text-zinc-300 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-zinc-900 mb-2">Settings</h2>
          <p className="text-zinc-500 max-w-md mx-auto">
            Configure default ticket dimensions, file upload limits, notification settings, and more.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
}

export function AnalyticsPage() {
  return (
    <DashboardLayout>
      <div className="p-6 lg:p-8">
        <div className="mb-6">
          <h1 className="text-3xl font-black tracking-tight text-zinc-900">Analytics</h1>
          <p className="text-zinc-500 mt-1">View detailed campaign analytics</p>
        </div>
        <div className="bg-white border border-zinc-200 rounded-sm p-12 text-center">
          <div className="w-16 h-16 bg-zinc-100 rounded-sm mx-auto mb-4 flex items-center justify-center">
            <span className="text-2xl font-bold text-zinc-400">📊</span>
          </div>
          <h2 className="text-xl font-bold text-zinc-900 mb-2">Analytics Dashboard</h2>
          <p className="text-zinc-500 max-w-md mx-auto">
            Detailed analytics with charts and insights coming soon. For now, view basic stats on the main dashboard.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
}
